import { Injectable } from '@angular/core';
import * as L from 'leaflet';

export const iconDefault = L.icon({
  iconRetinaUrl: 'assets/icons/Station.png',
  iconUrl: 'assets/icons/Station.png',
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
  tooltipAnchor: [16, -32],
});

export const iconVehicle = L.icon({
  iconRetinaUrl: 'assets/icons/VehicleMarker.png',
  iconUrl: 'assets/icons/VehicleMarker.png',
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
  tooltipAnchor: [16, -32]
});

export const iconLine = L.icon({
  iconRetinaUrl: 'assets/icons/LineMarker.png',
  iconUrl: 'assets/icons/LineMarker.png',
  iconSize: [7, 7],
  iconAnchor: [0, 7],
  popupAnchor: [0, -7],
  tooltipAnchor: [0, -7]
});

L.Marker.prototype.options.icon = iconDefault;

@Injectable({
  providedIn: 'root'
})
export class MapService {
  public map : L.Map;
  public markers : Array<any> = [];
  public lines : Array<any> = [];

  constructor() {}

  public initMap(idContainer : string, coordinates : L.LatLngExpression, zoom : number, stored? : boolean) : Promise<any> {
    const tiles = L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
      maxZoom: 19
    });

    if (stored === false) {
      return new Promise((resolve, reject) => {
        let map = L.map(idContainer, {
          center: coordinates,
          zoom: zoom,
          scrollWheelZoom: false,
          renderer: L.canvas()
        });
  
        tiles.addTo(map);
        resolve(map);
      });
    }
    return new Promise((resolve, reject) => {
      this.map = L.map(idContainer, {
        center: coordinates,
        zoom: zoom,
        scrollWheelZoom: false
      });
      this.markers = [];
      tiles.addTo(this.map);
      resolve(this.map);
    });
  }

  public flyTo({latitude, longitude, zoom}) : void {
    this.map.flyTo([latitude, longitude], zoom);
  }

  public getMarkers() : Array<L.Marker> {
    return this.markers;
  }

  public addMarker(coordinates : L.LatLngExpression, options? : any) : L.Marker {
    if (typeof options !== 'undefined' && typeof options.icon !== 'undefined' && options.icon === "vehicle") {
      options.icon = iconVehicle;
    }
    if (typeof options !== 'undefined' && typeof options.icon !== 'undefined' && options.icon === "line") {
      options.icon = iconLine;
    }
    if (typeof options !== 'undefined' && typeof options.type !== 'undefined' && options.type === "line") {
      options.type = "station";
    }
    var marker = L.marker(coordinates, options).addTo(this.map);

    this.markers.push(marker);
    return marker;
  }

  public drawPolyline(coordinates : Array<L.LatLngExpression>, options : L.PolylineOptions) : L.Polyline {
    var polyline = L.polyline(coordinates, options).addTo(this.map);

    this.lines.push(polyline);
    return polyline;
  }

  public removePolyline(id) : void {
    this.map.removeLayer(this.lines.find((line) => line._leaflet_id === id));
  }

  public removeMarker(id) : void {
    this.map.removeLayer(this.markers.find((marker) => marker._leaflet_id === id));
  }

  public resetView() : void {
    var group = L.featureGroup(this.markers);

    this.map.fitBounds(group.getBounds());
  }

  public resetLineView(polyline) : void {
    this.map.fitBounds(polyline.getBounds());
  }
}
